import { Stack, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { SelectMenu, type SelectMenuOption } from 'src/components/SelectMenu';
import { panelFieldLabelSx } from 'src/pages/Settings/memberships/styles';
import type { ConfigSurface } from 'src/pages/Settings/memberships/types';

const SURFACE_OPTIONS: (SelectMenuOption & { value: ConfigSurface })[] = [
  {
    value: 'memberships',
    title: 'Membership Options',
    icon: <DynamicIcon name="list-checks" library="lucide" />,
  },
  {
    value: 'landingPage',
    title: 'Landing Page',
    icon: <DynamicIcon name="layout-dashboard" library="lucide" />,
  },
  {
    value: 'termsOfService',
    title: 'Terms of Service',
    icon: <DynamicIcon name="scroll-text" library="lucide" />,
  },
  {
    value: 'privacyPolicy',
    title: 'Privacy Policy',
    icon: <DynamicIcon name="shield-check" library="lucide" />,
  },
];

type ConfigSurfaceSelectProps = {
  value: ConfigSurface;
  onChange: (surface: ConfigSurface) => void;
};

export const ConfigSurfaceSelect = ({ value, onChange }: ConfigSurfaceSelectProps) => (
  <Stack spacing={1}>
    <Typography variant="caption" sx={panelFieldLabelSx}>
      Page
    </Typography>
    <SelectMenu
      label="Page"
      options={SURFACE_OPTIONS}
      value={value}
      onChange={(next) => {
        const surface = SURFACE_OPTIONS.find((option) => option.value === next)?.value;
        if (surface) {
          onChange(surface);
        }
      }}
      menuWidth="trigger"
      sx={{ width: '100%' }}
    />
  </Stack>
);
